import { render, staticRenderFns } from "./game-room-main.vue?vue&type=template&id=1e528058&scoped=true&"
import script from "./game-room-main.vue?vue&type=script&lang=js&"
export * from "./game-room-main.vue?vue&type=script&lang=js&"
import style0 from "./game-room-main.vue?vue&type=style&index=0&id=1e528058&lang=scss&scoped=true&"
import style1 from "./game-room-main.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e528058",
  null
  
)

export default component.exports